import { render, staticRenderFns } from "./vendorCurrentAccount.vue?vue&type=template&id=66bd3201&scoped=true"
import script from "./vendorCurrentAccount.vue?vue&type=script&lang=js"
export * from "./vendorCurrentAccount.vue?vue&type=script&lang=js"
import style0 from "./vendorCurrentAccount.vue?vue&type=style&index=0&id=66bd3201&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bd3201",
  null
  
)

export default component.exports